/* global location, clearInterval, setInterval */

import React, { useEffect, useMemo } from "react";
import { Notification } from "@progress/kendo-react-notification";
import { NotificationToast } from "./NotificationManager";
import { formatMessage } from "../../utils/helpers/LanguageHelper";
import { mergeStyleSets } from "@fluentui/react";

interface NotificationMessageProps {
  notification: NotificationToast;
  showModalDetails?: (details) => void;
  onHide?: (notification) => void;
}

function isElapsed(notif: NotificationToast) {
  if (!notif.isTemporary == null || notif.startShowing == null) return true;
  return (new Date().getTime() - notif.startShowing) / 1000 < 5;
}

const classNames = mergeStyleSets({
  notificationDecoBorder: {
    height: "100%",
    width: "7px",
    minWidth: "7px",
    borderRadius: "3px",
  },
  notificationContainer: { display: "flex", flexDirection: "row", height: "100%", gap: "8px" },
  notificationIcon: { width: "16px", minWidth: "16px", height: "16px", marginTop: "2px" },
});
const NotificationItem: React.FunctionComponent<NotificationMessageProps> = (props) => {
  const { notification, showModalDetails, onHide } = props;

  useEffect(() => {
    const interval = setInterval(() => {
      if (notification.isTemporary && !isElapsed(notification)) {
        onHide(notification);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [props.notification]);

  const { notificationColor, iconSrc } = useMemo(() => {
    if (props.notification.type === "success")
      return { iconSrc: "/assets/success.svg", notificationColor: "var(--color-green)" };
    if (props.notification.type === "error")
      return { iconSrc: "/assets/error.svg", notificationColor: "var(--color-red)" };
    if (props.notification.type === "warning")
      return { iconSrc: "/assets/warning.svg", notificationColor: "var(--color-yellow)" };
    if (props.notification.type === "info")
      return { iconSrc: "/assets/success.svg", notificationColor: "var(--color-blue)" };
  }, [props.notification.type]);

  return (
    <Notification
      type={{ style: "none", icon: false }}
      closable={notification.closable}
      onClose={() => onHide(notification)}
    >
      <div className={classNames.notificationContainer}>
        <div
          className={classNames.notificationDecoBorder}
          style={{
            backgroundColor: notificationColor,
          }}
        />
        <img src={iconSrc} alt={notification.type} className={classNames.notificationIcon} />
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          {notification.title && <span className="notificationTitle">{notification.title?.toString()}</span>}
          <span className="bodyText">{notification.message?.toString()}</span>
          <div>
            {notification.enableReloadPanel && (
              <span
                onClick={() => {
                  location.reload();
                }}
                style={{ textDecoration: "underline", float: "right" }}
              >
                {formatMessage("cof.base.refreshpanel")}
              </span>
            )}
            {notification.details?.length > 0 && (
              <span
                onClick={() => {
                  showModalDetails(notification.details);
                }}
                style={{ textDecoration: "underline", float: "left" }}
              >
                {formatMessage("cof.base.details")}
              </span>
            )}
          </div>
        </div>
      </div>
    </Notification>
  );
};
export default NotificationItem;
